const info = [
    {
        title: "邮政快递",
        code: "youzhengbk",
    },
    {
        code: "youzhengguonei",
        title: "邮政快递包裹",
    },
    {
        code: "ems",
        title: "EMS",
    },
    {
        code: "pingxing",
        title: "平信",
    },
    {
        code: "shunfeng",
        title: "顺丰速运",
    },
    {
        code: "yuantong",
        title: "圆通速递",
    },

    {
        code: "yunda",
        title: "韵达快递",
    },
    {
        code: "zhongtong",
        title: "中通快递",
    },
    {
        code: "shentong",
        title: "申通快递",
    },



    {
        code: "jtexpress",
        title: "极兔速递",
    },
    {
        title: "京东物流",
        code: "jd",
    },
    {
        title: "百世快递",
        code: "huitongkuaidi",
    },

    {
        title: "中通国际",
        code: "zhongtongguoji",
    },
    {
        title: "丰网速运",
        code: "fengwang",
    },
    {
        title: "德邦",
        code: "debangwuliu",
    },
    {
        title: "德邦快递",
        code: "debangkuaidi",
    },
    {
        title: "韵达快运",
        code: "yundakuaiyun",
    },
];


const tempArr =  [
  {
      title: "邮政快递",
      code: "youzhengbk",
  },
  {
      code: "shunfeng",
      title: "顺丰速运",
  },
  {
      code: "yuantong",
      title: "圆通速递",
  },

  {
      code: "yunda",
      title: "韵达快递",
  },
  {
      code: "zhongtong",
      title: "中通快递",
  },
  {
      code: "shentong",
      title: "申通快递",
  },

  {
      title: "京东物流",
      code: "jd",
  },
  {
      title: "百世快递",
      code: "huitongkuaidi",
  }
];



const expressOjb= {
    yuantong: {
      code: "yuantong",
      title: "圆通速递",
    },
    pingxing: {
      code: "pingxing",
      title: "平信",
    },
    yunda: {
      code: "yunda",
      title: "韵达快递",
    },
    zhongtong: {
      code: "zhongtong",
      title: "中通快递",
    },
    shentong: {
      code: "shentong",
      title: "申通快递",
    },
    youzhengguonei: {
      code: "youzhengguonei",
      title: "邮政快递包裹",
    },
    shunfeng: {
      code: "shunfeng",
      title: "顺丰速运",
    },
    ems: {
      code: "ems",
      title: "EMS",
    },
    jtexpress: {
      code: "jtexpress",
      title: "极兔速递",
    },
    jd: {
      title: "京东物流",
      code: "jd",
    },
    huitongkuaidi: {
      title: "百世快递",
      code: "huitongkuaidi",
    },
    youzhengbk: {
      title: "邮政快递",
      code: "youzhengbk",
    },
    zhongtongguoji: {
      title: "中通国际",
      code: "zhongtongguoji",
    },
    fengwang: {
      title: "丰网速运",
      code: "fengwang",
    },
    debangwuliu: {
      title: "德邦",
      code: "debangwuliu",
    },
    debangkuaidi: {
      title: "德邦快递",
      code: "debangkuaidi",
    },
    yundakuaiyun: {
      title: "韵达快运",
      code: "yundakuaiyun",
    },
  };

module.exports ={
    arr:tempArr,
    obj:expressOjb
};


// WEBPACK FOOTER //
// ./src/util/expressInfo.js